import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaPhone } from "react-icons/fa";
import RollingCounter from "./RollingCounter";
import CountryAnimation from "./CountryAnimation";
import ClientAnimation from "./ClientAnimation";
import LiveIndicator from "./Live";

const StatCard = ({
  stat,
  index,
  colors,
  isCardAnimated,
  isHovered,
  autoAnimated,
  onMouseEnter,
  onMouseLeave,
  onClick
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const IconComponent = stat.icon;
  const isSpecialCard = stat.isSpecialDisplay;

  // Handle window resize to detect mobile view
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

const getMobileOrder = () => {
  if (!isMobile) return index;
  if (index === 2) return 3;  // 3rd card becomes 4th position
  if (index === 3) return 2;  // 4th card becomes 3rd position
  return index;  // index 0, 1, and any others remain unchanged
};

  const cardVariants = {
    hidden: { 
      opacity: 0, 
      y: 60,
      scale: 0.95
    },
    visible: { 
      opacity: 1, 
      y: 0,
      scale: 1,
      transition: { 
        duration: 0.7, 
        ease: [0.25, 0.46, 0.45, 0.94],
        delay: 0.4 + (index * 0.15),
      }
    }
  };

  return (
    <motion.div
      className={`stat-card ${isCardAnimated ? 'animate-card' : ''} ${stat.isClickable ? 'clickable-card' : ''} ${isHovered ? 'card-hovered' : ''}`}
      style={{ 
        animationDelay: `${index * 0.15}s`,
        order: getMobileOrder()
      }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-50px" }}
      variants={cardVariants}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {stat.showCountryAnimation && (
        <CountryAnimation isVisible={isCardAnimated} isHovered={isHovered} />
      )}

      {stat.showClientAnimation && (
        <ClientAnimation isVisible={isCardAnimated} isHovered={isHovered} />
      )}

      {stat.showLiveIndicator && <LiveIndicator />}

      <div className="stat-icon-wrapper">
        <IconComponent className="stat-icon" />
        {stat.isClickable && (
          <div className="phone-overlay">
            <FaPhone className="phone-icon" />
          </div>
        )}
      </div>
      
      <div className="stat-number">
        {isSpecialCard ? (
          <div className="support-text">{stat.specialText}</div>
        ) : (
          <RollingCounter
            targetCount={stat.count}
            duration={3000 + index * 200}
            delay={index * 200}
            shouldAnimate={autoAnimated && isCardAnimated}
          />
        )}
      </div>
      
      <h4 className="stat-title">{stat.title}</h4>
    </motion.div>
  );
};

export default StatCard;